import { render, staticRenderFns } from "./modalAddBalance.vue?vue&type=template&id=1f76c549"
import script from "./modalAddBalance.vue?vue&type=script&lang=js"
export * from "./modalAddBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports